import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FunctionalLoader } from 'seagull';
import { LoginScreen } from "../unAuthorizedPages";
import { useStore } from "../../contexts";
import ImpersonateWarning from "../../components/ImpersonateWarning/ImpersonateWarning";
import FeatureFlagsGuard from "../../components/FeatureFlagsGuard/FeatureFlagsGuard";
import { useEventReporter } from "../../event-reporter";
import KycStatusBinder from "../../components/KycStatusBinder";
import FeatureFlagsFetcher from "../../components/FeatureFlagsFetcher/FeatureFlagsFetcher";
import 'seagull/foundations/font-face.scss';
import { selectors } from "../../store/state-selectors";
import { useSyncUserDataBetweenTabs } from "../../hooks/useSyncUserDataBetweenTabs";
import { useSessionTimeout } from "../../hooks/useSessionTimeout";
import MainPages from "./MainPages";
import { withOptimizedMobileViewport } from "../../providers/MobileViewportWidthProvider";
import { BusinessPartyTypeEnum } from "../../store/store.model";
import { unauthorizedPages, authorizedPages } from "../../utils/routeConfigs";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BeforeAuthFlowDone = withOptimizedMobileViewport(() => /*#__PURE__*/_jsx(FunctionalLoader, {
  name: "waitForAuthFlowDone",
  show: true
}));
const LoggedOutComponent = withOptimizedMobileViewport(LoginScreen);
export default function Main() {
  const hasUserInfo = useStore(selectors.user.hasUserInfo);
  const isResetPasswordFlow = useStore(selectors.isResetPasswordFlow);
  const hasAuthToken = useStore(state => state.authToken != null);
  const authFlowDone = useStore(state => state.authFlowDone);
  const worksAt = useStore(selectors.user.business);
  const isWaitingForUserInfo = hasAuthToken && !isResetPasswordFlow && !hasUserInfo;
  const location = useLocation();
  const {
    reportPageView
  } = useEventReporter();
  useSyncUserDataBetweenTabs();
  useSessionTimeout();
  useEffect(() => {
    reportPageView(location.pathname, (worksAt === null || worksAt === void 0 ? void 0 : worksAt.type) == BusinessPartyTypeEnum.Vendor, worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
  }, [location, worksAt]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(KycStatusBinder, {}), /*#__PURE__*/_jsx(FeatureFlagsFetcher, {}), /*#__PURE__*/_jsx(ImpersonateWarning, {}), /*#__PURE__*/_jsx(FunctionalLoader, {
      name: "waitingForUserInfo",
      show: isWaitingForUserInfo
    }), authFlowDone ? /*#__PURE__*/_jsx(FeatureFlagsGuard, {
      children: /*#__PURE__*/_jsx(MainPages, {
        authorizedPages: authorizedPages,
        unauthorizedPages: unauthorizedPages,
        LoggedOutComponent: LoggedOutComponent
      })
    }) : /*#__PURE__*/_jsx(BeforeAuthFlowDone, {})]
  });
}